import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import '@/assets/css/style.css'
import Echarts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/title'
import VueSession from 'vue-session'

Vue.use(VueSession, { persist: true })
Vue.config.productionTip = false
Vue.component('v-chart', Echarts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
